import {numbers} from "../sheets";
import {zoomStyles} from "./styles";
import {zoomSizes} from "./resize";

const readyZoom = {};

export function init(view) {
	view.attachEvent("onUndo", (action, row, column, value) => {
		if (action == "zoom"){
			zoom(view, value);
		}
	});

	view.attachEvent("onDataSerialize", (data) => serialize(view, data));
	view.attachEvent("onDataParse", (data) => load(view, data));
}

export function zoom(view, newValue, load){
	const grid = view.$$("cells");
	const value = view._zoom || 1;

	if(newValue == "in" || newValue == "out")
		newValue = webix.ui["ssheet-zoom"].prototype.getNext(value, newValue == "in" ? 1 : -1, numbers);

	view._zoom = newValue;
	grid.define({ minColumnWidth: 40*newValue });

	if(view.$$("zoom"))
		view.$$("zoom").setValue(newValue);

	if(newValue != value){
		const fontSize = webix.skin.$active.fontSize * newValue;
		const rowHeight = webix.skin.$name == "contrast" || webix.skin.$name == "flat" ? 24 : 20;
		const className = "webix_ssheet_zoom_"+newValue.toString().replace(".", "_");

		grid.$view.className = grid.$view.className.replace(/ webix_ssheet_zoom_\w+/,"");
		grid.define({css: className});

		if(!load){
			zoomSizes(view, value);
			zoomStyles(view);

			view.callEvent("onZoom", [newValue, value]);
		}

		if(!readyZoom[className] && newValue != 1){
			readyZoom[className] = 1;

			// cells
			webix.html.addStyle(`
				.${className} .webix_hcell, .${className} .webix_cell{
					font-size: ${fontSize}px;
				}

				.${className} .sheet_column_0 .webix_cell{
					padding: 0 ${12*newValue}px;
				}

				.${className}.webix_ssheet_table .webix_hs_left .webix_hcell.webix_first:before{
					right: ${4*newValue}px;
					bottom: ${4*newValue}px;
					border-top-width: ${(rowHeight - 8)*newValue}px;
					border-right-width: ${(rowHeight - 8)*newValue}px;
				}

				.${className} .webix_cell{
					padding: ${2*newValue}px 0px;
				}

				.${className} .webix_cell div:first-child{
					margin: 0 ${12*newValue}px;
				}
			`);

			// icons
			webix.html.addStyle(`
				.${className} .webix_cell.ss_filter, .${className} .webix_cell.ss_editor{
					padding-right: ${16*newValue}px;
				}
				.${className} .ssheet_filter_sign, .${className} .webix_cell.ss_editor:after{
					font-size: ${20*newValue}px;
					right: ${6*newValue}px;
				}
				.${className} .webix_cell.ss_filter.ss_editor:after{
					right: ${28*newValue}px;
				}
				.${className} .webix_cell.ss_filter.ss_editor{
					padding-right: ${36*newValue}px;
				}
				.${className} .webix_lock:before{
					font-size: ${fontSize}px;
				}
				.${className} .ssheet_commented_sign:before{
					border-top-width: ${8*newValue}px;
					border-left-width: ${8*newValue}px;
				}
			`);
		}
	}
}

export function serialize(view, data){
	data.table = {
		zoom: view._zoom
	};
}

export function load(view, data){
	let value = 1;
	if(data.table && data.table.zoom)
		value = data.table.zoom;

	zoom(view, value, true);
}